import { useEffect } from "react";
import { useSetRecoilState } from "recoil";

import { getLastDayOfTwoMonthsLater } from "../../utils/date-format/dateUtils";
import { ServerCalendarBlockType } from "../../types/block/BlockType";
import { mobaCalendarListState } from "../../recoil/calendar/mobaCalendarListState";
import { useProcessCalendarBlocks } from "./useProcessCalendarBlocks";
import { optimisticBlockStore } from "../../services/block/optimisticBlockStore";
import { mergeClientServerBlocks } from "../../services/optimistic-updates/block-merger";

export function useInitializeCalendarState(
  serverData: ServerCalendarBlockType[] | undefined,
  isFetching: boolean,
  calendarLastMonth: string | null
) {
  const setMobaCalendarList = useSetRecoilState(mobaCalendarListState);
  const { processInitialCalendarBlocks } = useProcessCalendarBlocks();

  useEffect(() => {
    if (!serverData || isFetching) return;

    const recurringEnd = calendarLastMonth
      ? getLastDayOfTwoMonthsLater(calendarLastMonth)
      : new Date();

    const initialProcessedCalendarBlocks = processInitialCalendarBlocks(serverData, recurringEnd);

    // NOTE 서버 데이터와 낙관적 업데이트 데이터 머지해서 뷰에 반영
    const mergedBlocks = mergeClientServerBlocks(
      initialProcessedCalendarBlocks,
      optimisticBlockStore.getAll()
    );

    setMobaCalendarList(mergedBlocks);
  }, [serverData, isFetching, calendarLastMonth]);
}
